export const blurFocusedPopover = () => {
  const { activeElement } = document;

  if (!activeElement || typeof activeElement.closest !== "function") return;

  if (activeElement.closest(".MuiPopover-root")) {
    activeElement.blur();
  }
};
